import { render, staticRenderFns } from "./SandboxViewsTabComponent.vue?vue&type=template&id=12d143d0&scoped=true"
import script from "./SandboxViewsTabComponent.vue?vue&type=script&lang=js"
export * from "./SandboxViewsTabComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d143d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d143d0')) {
      api.createRecord('12d143d0', component.options)
    } else {
      api.reload('12d143d0', component.options)
    }
    module.hot.accept("./SandboxViewsTabComponent.vue?vue&type=template&id=12d143d0&scoped=true", function () {
      api.rerender('12d143d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/SandboxViewsTabComponent.vue"
export default component.exports